import CollectionFiltersForm from "./collection-filters-form";

export default CollectionFiltersForm;